import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { GrainOverlay } from './components/GrainOverlay';
import { Nav } from './components/Nav';
import { Home } from './pages/Home';
import { Music } from './pages/Music';
import { Film } from './pages/Film';
function AppShell() {
  return <div className="min-h-screen bg-darkroom-900 text-zinc-300 font-serif selection:bg-darkroom-red selection:text-white flex flex-col" data-id="element-0">
      <GrainOverlay data-id="element-1" />
      <Nav data-id="element-2" />

      <div className="flex-1" data-id="element-3">
        <Routes data-id="element-4">
          <Route path="/" element={<Home data-id="element-6" />} data-id="element-5" />
          <Route path="/music" element={<Music data-id="element-8" />} data-id="element-7" />
          <Route path="/film" element={<Film data-id="element-10" />} data-id="element-9" />
        </Routes>
      </div>
    </div>;
}
export function App() {
  return <BrowserRouter data-id="element-11">
      <AppShell data-id="element-12" />
    </BrowserRouter>;
}